import { get, post, put, del } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

// Action Types
const FETCH_PORTFOLIOS_REQUEST = 'FETCH_PORTFOLIOS_REQUEST';
const FETCH_PORTFOLIOS_SUCCESS = 'FETCH_PORTFOLIOS_SUCCESS';
const FETCH_PORTFOLIOS_ERROR = 'FETCH_PORTFOLIOS_ERROR';

const CREATE_PORTFOLIO_REQUEST = 'CREATE_PORTFOLIO_REQUEST';
const CREATE_PORTFOLIO_SUCCESS = 'CREATE_PORTFOLIO_SUCCESS';
const CREATE_PORTFOLIO_ERROR = 'CREATE_PORTFOLIO_ERROR';

const UPDATE_PORTFOLIO_REQUEST = 'UPDATE_PORTFOLIO_REQUEST';
const UPDATE_PORTFOLIO_SUCCESS = 'UPDATE_PORTFOLIO_SUCCESS';
const UPDATE_PORTFOLIO_ERROR = 'UPDATE_PORTFOLIO_ERROR';

const DELETE_PORTFOLIO_REQUEST = 'DELETE_PORTFOLIO_REQUEST';
const DELETE_PORTFOLIO_SUCCESS = 'DELETE_PORTFOLIO_SUCCESS';
const DELETE_PORTFOLIO_ERROR = 'DELETE_PORTFOLIO_ERROR';

const FETCH_PORTFOLIO_BY_ID_REQUEST = 'FETCH_PORTFOLIO_BY_ID_REQUEST';
const FETCH_PORTFOLIO_BY_ID_SUCCESS = 'FETCH_PORTFOLIO_BY_ID_SUCCESS';
const FETCH_PORTFOLIO_BY_ID_ERROR = 'FETCH_PORTFOLIO_BY_ID_ERROR';

const ADD_USER_TO_PORTFOLIO_REQUEST = 'ADD_USER_TO_PORTFOLIO_REQUEST';
const ADD_USER_TO_PORTFOLIO_SUCCESS = 'ADD_USER_TO_PORTFOLIO_SUCCESS';
const ADD_USER_TO_PORTFOLIO_ERROR = 'ADD_USER_TO_PORTFOLIO_ERROR';

const UPDATE_PORTFOLIO_USER_REQUEST = 'UPDATE_PORTFOLIO_USER_REQUEST';
const UPDATE_PORTFOLIO_USER_SUCCESS = 'UPDATE_PORTFOLIO_USER_SUCCESS';
const UPDATE_PORTFOLIO_USER_ERROR = 'UPDATE_PORTFOLIO_USER_ERROR';

const FETCH_PORTFOLIO_PROPERTIES_REQUEST = 'FETCH_PORTFOLIO_PROPERTIES_REQUEST';
const FETCH_PORTFOLIO_PROPERTIES_SUCCESS = 'FETCH_PORTFOLIO_PROPERTIES_SUCCESS';
const FETCH_PORTFOLIO_PROPERTIES_ERROR = 'FETCH_PORTFOLIO_PROPERTIES_ERROR';

const FETCH_AVAILABLE_PROPERTIES_REQUEST = 'FETCH_AVAILABLE_PROPERTIES_REQUEST';
const FETCH_AVAILABLE_PROPERTIES_SUCCESS = 'FETCH_AVAILABLE_PROPERTIES_SUCCESS';
const FETCH_AVAILABLE_PROPERTIES_ERROR = 'FETCH_AVAILABLE_PROPERTIES_ERROR';

const ADD_PROPERTY_TO_PORTFOLIO_REQUEST = 'ADD_PROPERTY_TO_PORTFOLIO_REQUEST';
const ADD_PROPERTY_TO_PORTFOLIO_SUCCESS = 'ADD_PROPERTY_TO_PORTFOLIO_SUCCESS';
const ADD_PROPERTY_TO_PORTFOLIO_ERROR = 'ADD_PROPERTY_TO_PORTFOLIO_ERROR';

const FETCH_PORTFOLIO_NOTIFICATIONS_REQUEST =
	'FETCH_PORTFOLIO_NOTIFICATIONS_REQUEST';
const FETCH_PORTFOLIO_NOTIFICATIONS_SUCCESS =
	'FETCH_PORTFOLIO_NOTIFICATIONS_SUCCESS';
const FETCH_PORTFOLIO_NOTIFICATIONS_ERROR =
	'FETCH_PORTFOLIO_NOTIFICATIONS_ERROR';

const REMOVE_PROPERTY_FROM_PORTFOLIO_SET_REQUEST =
	'REMOVE_PROPERTY_FROM_PORTFOLIO_SET_REQUEST';
const REMOVE_PROPERTY_FROM_PORTFOLIO_SET_SUCCESS =
	'REMOVE_PROPERTY_FROM_PORTFOLIO_SET_SUCCESS';
const REMOVE_PROPERTY_FROM_PORTFOLIO_SET_ERROR =
	'REMOVE_PROPERTY_FROM_PORTFOLIO_SET_ERROR';

const FETCH_PROPERTY_IN_PORTFOLIO_SET_REQUEST =
	'FETCH_PROPERTY_IN_PORTFOLIO_SET_REQUEST';
const FETCH_PROPERTY_IN_PORTFOLIO_SET_SUCCESS =
	'FETCH_PROPERTY_IN_PORTFOLIO_SET_SUCCESS';
const FETCH_PROPERTY_IN_PORTFOLIO_SET_ERROR =
	'FETCH_PROPERTY_IN_PORTFOLIO_SET_ERROR';

// Property Assignment to Users (Viewer Access Control)
const FETCH_USER_ASSIGNED_PROPERTIES_REQUEST =
	'FETCH_USER_ASSIGNED_PROPERTIES_REQUEST';
const FETCH_USER_ASSIGNED_PROPERTIES_SUCCESS =
	'FETCH_USER_ASSIGNED_PROPERTIES_SUCCESS';
const FETCH_USER_ASSIGNED_PROPERTIES_ERROR =
	'FETCH_USER_ASSIGNED_PROPERTIES_ERROR';

const ASSIGN_USERS_TO_PROPERTY_REQUEST = 'ASSIGN_USERS_TO_PROPERTY_REQUEST';
const ASSIGN_USERS_TO_PROPERTY_SUCCESS = 'ASSIGN_USERS_TO_PROPERTY_SUCCESS';
const ASSIGN_USERS_TO_PROPERTY_ERROR = 'ASSIGN_USERS_TO_PROPERTY_ERROR';

const REMOVE_USER_FROM_PROPERTY_REQUEST = 'REMOVE_USER_FROM_PROPERTY_REQUEST';
const REMOVE_USER_FROM_PROPERTY_SUCCESS = 'REMOVE_USER_FROM_PROPERTY_SUCCESS';
const REMOVE_USER_FROM_PROPERTY_ERROR = 'REMOVE_USER_FROM_PROPERTY_ERROR';

const CLEAR_PORTFOLIO_ERRORS = 'CLEAR_PORTFOLIO_ERRORS';
const CLEAR_SELECTED_PORTFOLIO = 'CLEAR_SELECTED_PORTFOLIO';

// Initial State
const initialState = {
	portfolios: [],
	/** Portfolios where current user can add properties (owner or admin). Set when fetchPortfoliosLegacy({ forAddProperty: true }) is used. */
	portfoliosForAdd: [],
	selectedPortfolio: null,
	// Properties for selected portfolio
	properties: [],
	// Available properties for adding to portfolio
	availableProperties: [],
	isLoading: false,
	isCreating: false,
	isUpdating: false,
	isDeleting: false,
	isLoadingSelected: false,
	isLoadingProperties: false,
	isLoadingAvailableProperties: false,
	isAddingUser: false,
	isUpdatingUser: false,
	isAddingProperty: false,
	isRemovingProperty: false,
	error: null,
	createError: null,
	updateError: null,
	deleteError: null,
	selectedError: null,
	propertiesError: null,
	availablePropertiesError: null,
	addUserError: null,
	updateUserError: null,
	addPropertyError: null,
	removePropertyError: null,
	// Portfolio sets pagination
	totalCount: 0,
	currentPage: 1,
	perPage: 12,
	// Properties pagination
	propertiesTotalCount: 0,
	propertiesCurrentPage: 1,
	propertiesPerPage: 6,
	// Notifications for selected portfolio
	notifications: [],
	isLoadingNotifications: false,
	notificationsError: null,
	// Notifications pagination
	notificationsTotalCount: 0,
	notificationsCurrentPage: 1,
	notificationsPerPage: 10,
	// Property in portfolio set data
	propertyInPortfolioSet: null,
	propertyPortfolioSets: [],
	propertyUsers: [],
	isLoadingPropertyInPortfolioSet: false,
	propertyInPortfolioSetError: null,
	// User assigned properties (for viewer access control)
	userAssignedProperties: [],
	isLoadingUserAssignedProperties: false,
	userAssignedPropertiesError: null,
	isAssigningUsersToProperty: false,
	assignUsersError: null,
};

// Action Creators

// Fetch Portfolio Sets (Portfolios) - Updated to use paginated endpoint
export const fetchPortfolios =
	(page = 1, perPage = 12, filters = {}) =>
	(dispatch, getState) => {
		const state = getState();
		// Use the new paginated endpoint
		const url = `${API_URL}/api/portfolio-sets/paginated`;
		const params = new URLSearchParams({
			page: page.toString(),
			per_page: perPage.toString(),
			// Add filters if needed in the future
			...filters,
		});

		dispatch(fetchPortfoliosRequest());

		return get({
			dispatch,
			url: `${url}?${params.toString()}`,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				// New paginated endpoint returns { data: [], pagination: {}, totalCount, currentPage, perPage }
				dispatch(
					fetchPortfoliosSuccess({
						data: result.data || [],
						total: result.totalCount || result.pagination?.total || 0,
						page: result.currentPage || result.pagination?.current_page || 1,
						per_page: result.perPage || result.pagination?.per_page || perPage,
						pagination: result.pagination,
					}),
				);
			},
			onError: (error) => dispatch(fetchPortfoliosError(error)),
		});
	};

// Legacy fetch method (keeping for backward compatibility).
// Options: { forAddProperty: true } — also sets portfoliosForAdd to portfolios where user can add properties (owner or admin; excludes viewer).
export const fetchPortfoliosLegacy =
	(options = {}) =>
	(dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets`;
		const { forAddProperty = false } = options;

		dispatch(fetchPortfoliosRequest());

		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				// API response structure: { success: true, message: "...", data: { owned: [], shared: [] } }
				// Handle both wrapped (ApiResponse) and direct response formats
				const responseData = result.data || result;
				const owned = responseData.owned || [];
				const shared = responseData.shared || [];

				// Combine owned and shared portfolio sets; add isOwned and role for permission checks
				const allPortfolios = [...owned, ...shared];
				const portfoliosWithOwnership = allPortfolios.map((portfolio) => {
					const isOwned = owned.some((o) => o.id === portfolio.id);
					return {
						...portfolio,
						isOwned,
						role: isOwned ? 'owner' : portfolio.pivot?.role,
					};
				});

				const payload = {
					portfolios: portfoliosWithOwnership,
					data: portfoliosWithOwnership,
					total: allPortfolios.length,
					totalCount: allPortfolios.length,
					page: 1,
					currentPage: 1,
					per_page: allPortfolios.length,
					perPage: allPortfolios.length,
				};

				if (forAddProperty) {
					payload.portfoliosForAdd = portfoliosWithOwnership.filter(
						(p) => p.isOwned || p.role === 'admin',
					);
				} else {
					payload.portfoliosForAdd = [];
				}

				dispatch(fetchPortfoliosSuccess(payload));
			},
			onError: (error) => dispatch(fetchPortfoliosError(error)),
		});
	};

// Create Portfolio Set
export const createPortfolio = (portfolioData) => (dispatch, getState) => {
	const state = getState();
	const url = `${API_URL}/api/portfolio-sets`;

	dispatch(createPortfolioRequest());

	// Transform data to match Laravel PortfolioSet structure
	const portfolioSetData = {
		name: portfolioData.name,
		company: portfolioData.company || '',
		users: portfolioData?.users || [],
		// We'll handle user addition after portfolio set creation
	};

	return new Promise((resolve, reject) => {
		post({
			dispatch,
			url,
			authToken: state.user.authToken,
			data: portfolioSetData,
			onSuccess: async (result) => {
				dispatch(createPortfolioSuccess(result));
				// Refresh the portfolios list with current pagination
				const currentState = getState().portfoliosManagement;
				dispatch(
					fetchPortfolios(currentState.currentPage, currentState.perPage),
				);
				resolve(result);
			},
			onError: (error) => {
				dispatch(createPortfolioError(error.message || error));
				reject(error);
			},
		});
	});
};

// Update Portfolio Set
export const updatePortfolio =
	(portfolioId, portfolioData) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioId}`;

		dispatch(updatePortfolioRequest());

		// Transform data to match Laravel PortfolioSet structure
		const portfolioSetData = {
			name: portfolioData.name,
			company: portfolioData.company || '',
			users: portfolioData.users || [], // Include users for update
		};

		return new Promise((resolve, reject) => {
			put({
				dispatch,
				url,
				authToken: state.user.authToken,
				data: portfolioSetData,
				onSuccess: async (result) => {
					dispatch(updatePortfolioSuccess(result));
					// Refresh the portfolios list with current pagination
					const currentState = getState().portfoliosManagement;
					dispatch(
						fetchPortfolios(currentState.currentPage, currentState.perPage),
					);
					resolve(result);
				},
				onError: (error) => {
					dispatch(updatePortfolioError(error.message || error));
					reject(error);
				},
			});
		});
	};

// Delete Portfolio Set
export const deletePortfolio = (portfolioId) => (dispatch, getState) => {
	const state = getState();
	const url = `${API_URL}/api/portfolio-sets/${portfolioId}`;

	dispatch(deletePortfolioRequest());

	return del({
		dispatch,
		url,
		authToken: state.user.authToken,
		onSuccess: () => {
			dispatch(deletePortfolioSuccess(portfolioId));
			// Refresh the portfolios list after deletion with current pagination
			const currentState = getState().portfoliosManagement;
			dispatch(fetchPortfolios(currentState.currentPage, currentState.perPage));
		},
		onError: (error) => dispatch(deletePortfolioError(error)),
	});
};

// Fetch Single Portfolio Set by ID
export const fetchPortfolioById = (portfolioId) => (dispatch, getState) => {
	const state = getState();
	// Laravel doesn't have a single portfolio set endpoint, so we'll fetch all and filter
	const url = `${API_URL}/api/portfolio-sets/${portfolioId}`;

	dispatch(fetchPortfolioByIdRequest());

	return get({
		dispatch,
		url,
		authToken: state.user.authToken,
		onSuccess: (result) => {
			if (result) {
				dispatch(fetchPortfolioByIdSuccess(result));
			} else {
				dispatch(fetchPortfolioByIdError({ message: 'Portfolio not found' }));
			}
		},
		onError: (error) => dispatch(fetchPortfolioByIdError(error)),
	});
};

// Add User to Portfolio Set with proper state management
export const addUserToPortfolio =
	(portfolioId, userData) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioId}/users`;

		dispatch(addUserToPortfolioRequest());

		return new Promise((resolve, reject) => {
			post({
				dispatch,
				url,
				authToken: state.user.authToken,
				data: {
					email: userData.email,
					type: userData.userType || 'user',
				},
				onSuccess: (result) => {
					dispatch(addUserToPortfolioSuccess());
					// Optionally refresh portfolios to get updated user list
					const currentState = getState().portfoliosManagement;
					dispatch(
						fetchPortfolios(currentState.currentPage, currentState.perPage),
					);
					resolve(result);
				},
				onError: (error) => {
					console.error('Error adding user to portfolio:', error);
					dispatch(addUserToPortfolioError(error.message || error));
					reject(error);
				},
			});
		});
	};

// Update User in Portfolio Set
export const updatePortfolioUser =
	(portfolioId, userId, userData) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioId}/users/${userId}`;

		dispatch(updatePortfolioUserRequest());

		return new Promise((resolve, reject) => {
			put({
				dispatch,
				url,
				authToken: state.user.authToken,
				data: {
					type: userData.userType || userData.type,
				},
				onSuccess: (result) => {
					dispatch(updatePortfolioUserSuccess(result));
					resolve(result);
				},
				onError: (error) => {
					console.error('Error updating user in portfolio:', error);
					dispatch(updatePortfolioUserError(error.message || error));
					reject(error);
				},
			});
		});
	};

// Remove User from Portfolio Set
export const removeUserFromPortfolio =
	(portfolioId, userId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioId}/users/${userId}`;

		return del({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				// Refresh portfolios to get updated user list
				dispatch(fetchPortfolios());
				return result;
			},
			onError: (error) => {
				console.error('Error removing user from portfolio:', error);
				throw error;
			},
		});
	};

// Add Property to Portfolio Set
export const addPropertyToPortfolio =
	(portfolioId, propertyId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolios`;

		return post({
			dispatch,
			url,
			authToken: state.user.authToken,
			data: {
				portfolio_set_id: portfolioId,
				property_id: propertyId,
			},
			onSuccess: (result) => {
				// Optionally refresh the portfolios to get updated property list
				// You might want to update selectedPortfolio if viewing details
				return result;
			},
			onError: (error) => {
				console.error('Error adding property to portfolio:', error);
				throw error;
			},
		});
	};

// Remove Property from Portfolio Set
export const removePropertyFromPortfolio =
	(portfolioId, propertyId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolios/${portfolioId}/${propertyId}`;

		return del({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				// Optionally refresh the portfolios to get updated property list
				return result;
			},
			onError: (error) => {
				console.error('Error removing property from portfolio:', error);
				throw error;
			},
		});
	};

// Get Properties for a specific Portfolio Set with pagination support
export const getPortfolioProperties =
	(portfolioId, page = 1, perPage = 6, filters = {}) =>
	(dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioId}/properties`;
		const params = new URLSearchParams({
			page: page.toString(),
			per_page: perPage.toString(),
			// Add filters if needed in the future
			...filters,
		});

		dispatch(fetchPortfolioPropertiesRequest());

		return get({
			dispatch,
			url: `${url}?${params.toString()}`,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				const propertiesList = Array.isArray(result)
					? result
					: result?.data || result?.properties || [];
				const totalCount =
					result?.total ??
					(result?.last_page && result?.per_page
						? result.last_page * result.per_page
						: null) ??
					(Array.isArray(result)
						? result.length
						: result?.total_count || propertiesList.length);
				const currentPage = result?.current_page || page || 1;
				const perPageCount = result?.per_page || perPage || 10;
				const totalPages =
					result?.last_page || Math.ceil((totalCount || 1) / perPageCount);

				if (perPage === 10000) {
					dispatch(
						fetchPortfolioAllPropertiesSuccess({
							data: propertiesList,
						}),
					);
				} else {
					dispatch(
						fetchPortfolioPropertiesSuccess({
							data: propertiesList,
							total: totalCount,
							page: currentPage,
							per_page: perPageCount,
							total_pages: totalPages,
						}),
					);
				}

				return result;
			},
			onError: (error) => {
				console.error('Error fetching portfolio properties:', error);
				dispatch(fetchPortfolioPropertiesError(error));
				throw error;
			},
		});
	};

// Legacy getPortfolioProperties for backward compatibility
export const getPortfolioPropertiesLegacy =
	(portfolioId) => (dispatch, getState) => {
		return getPortfolioProperties(portfolioId, 1, 100)(dispatch, getState);
	};

// Fetch Available Properties for User in Portfolio Set
export const fetchAvailableProperties =
	(portfolioSetId, userId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/users/${userId}/available-properties`;

		dispatch(fetchAvailablePropertiesRequest());

		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				dispatch(fetchAvailablePropertiesSuccess(result.data));
				return result.data;
			},
			onError: (error) => {
				console.error('Error fetching available properties:', error);
				dispatch(fetchAvailablePropertiesError(error));
				throw error;
			},
		});
	};

// Add Property to Portfolio with Redux state management
export const addPropertyToPortfolioWithState =
	(portfolioSetId, propertyId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/portfolios`;

		dispatch(addPropertyToPortfolioRequest());

		return new Promise((resolve, reject) => {
			post({
				dispatch,
				url,
				authToken: state.user.authToken,
				data: {
					portfolioSetId: portfolioSetId,
					propertyId: propertyId,
				},
				onSuccess: (result) => {
					dispatch(addPropertyToPortfolioSuccess(result));
					// Refresh available properties to update the list
					const currentUser = state.user.currentUser;
					if (currentUser?.id) {
						dispatch(fetchAvailableProperties(portfolioSetId, currentUser.id));
					}
					// Optionally refresh portfolio properties
					dispatch(getPortfolioProperties(portfolioSetId));
					resolve(result);
				},
				onError: (error) => {
					console.error('Error adding property to portfolio:', error);
					dispatch(addPropertyToPortfolioError(error.message || error));
					reject(error);
				},
			});
		});
	};

// Remove Property from Portfolio Set with proper state management
export const removePropertyFromPortfolioSet =
	(portfolioSetId, propertyId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/properties/${propertyId}`;

		dispatch(removePropertyFromPortfolioSetRequest());

		return del({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: () => {
				// Callers reload what they show: the portfolio page reloads its own (v2) property list page
				dispatch(removePropertyFromPortfolioSetSuccess());
			},
			onError: (error) => {
				console.error('Error removing property from portfolio set:', error);
				dispatch(removePropertyFromPortfolioSetError(error.message || error));
				throw error;
			},
		});
	};

// Get Notifications for a specific Portfolio Set with pagination support
export const getPortfolioNotifications =
	(portfolioId, page = 1, perPage = 10, filters = {}) =>
	(dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioId}/notifications`;
		const params = new URLSearchParams({
			page: page.toString(),
			per_page: perPage.toString(),
			// Add filters if needed in the future
			...filters,
		});

		dispatch(fetchPortfolioNotificationsRequest());

		return get({
			dispatch,
			url: `${url}?${params.toString()}`,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				const notificationsList = Array.isArray(result)
					? result
					: result?.data || result?.notifications || [];
				const totalCount =
					result?.total ??
					(Array.isArray(result) ? result.length : notificationsList.length);
				const currentPage = result?.current_page || page || 1;
				const perPageCount = result?.per_page || perPage || 10;
				const totalPages =
					result?.last_page ||
					result?.total_pages ||
					Math.ceil((totalCount || 1) / perPageCount);

				dispatch(
					fetchPortfolioNotificationsSuccess({
						data: notificationsList,
						total: totalCount,
						page: currentPage,
						per_page: perPageCount,
						total_pages: totalPages,
					}),
				);
				return result;
			},
			onError: (error) => {
				console.error('Error fetching portfolio notifications:', error);
				dispatch(fetchPortfolioNotificationsError(error));
				throw error;
			},
		});
	};

// Get Property Details in Portfolio Set
export const fetchPropertyInPortfolioSet =
	(portfolioSetId, propertyId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/properties/${propertyId}`;

		dispatch(fetchPropertyInPortfolioSetRequest());

		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (response) => {
				const result = response.data;
				dispatch(
					fetchPropertyInPortfolioSetSuccess({
						property: result.property || result,
						portfolioSets: result.attachedPortfolioSets || [],
						users: result.propertyUsers || [],
					}),
				);
				return result;
			},
			onError: (error) => {
				console.error('Error fetching property in portfolio set:', error);
				dispatch(fetchPropertyInPortfolioSetError(error));
				throw error;
			},
		});
	};

// Get User's Assigned Properties (for viewer access control)
export const fetchUserAssignedProperties =
	(portfolioSetId, userId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/users/${userId}/assigned-properties`;

		dispatch(fetchUserAssignedPropertiesRequest());

		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (properties) => {
				dispatch(fetchUserAssignedPropertiesSuccess(properties));
				return properties;
			},
			onError: (error) => {
				console.error('Error fetching user assigned properties:', error);
				dispatch(fetchUserAssignedPropertiesError(error.message || error));
				throw error;
			},
		});
	};

// Assign Users to Property (for viewer access control)
export const assignUsersToProperty =
	(portfolioSetId, portfolioId, userIds) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/portfolios/${portfolioId}/assign-users`;

		dispatch(assignUsersToPropertyRequest());

		return new Promise((resolve, reject) => {
			post({
				dispatch,
				url,
				authToken: state.user.authToken,
				data: { user_ids: userIds },
				onSuccess: (result) => {
					dispatch(assignUsersToPropertySuccess(result));
					resolve(result);
				},
				onError: (error) => {
					console.error('Error assigning users to property:', error);
					dispatch(assignUsersToPropertyError(error.message || error));
					reject(error);
				},
			});
		});
	};

// Remove User from Property (for viewer access control)
export const removeUserFromProperty =
	(portfolioSetId, portfolioId, userId) => (dispatch, getState) => {
		const state = getState();
		const url = `${API_URL}/api/portfolio-sets/${portfolioSetId}/portfolios/${portfolioId}/users/${userId}`;

		dispatch(removeUserFromPropertyRequest());

		return del({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: () => {
				dispatch(removeUserFromPropertySuccess());
			},
			onError: (error) => {
				console.error('Error removing user from property:', error);
				dispatch(removeUserFromPropertyError(error.message || error));
				throw error;
			},
		});
	};

// Utility Actions
export const clearPortfolioErrors = () => ({
	type: CLEAR_PORTFOLIO_ERRORS,
});

export const clearSelectedPortfolio = () => ({
	type: CLEAR_SELECTED_PORTFOLIO,
});

// Action Creator Functions
export const fetchPortfoliosRequest = () => ({
	type: FETCH_PORTFOLIOS_REQUEST,
	payload: {
		isLoading: true,
		error: null,
	},
});

export const fetchPortfoliosSuccess = (data) => ({
	type: FETCH_PORTFOLIOS_SUCCESS,
	payload: {
		isLoading: false,
		portfolios: data.portfolios || data.data || data,
		...(data.portfoliosForAdd !== undefined && {
			portfoliosForAdd: data.portfoliosForAdd,
		}),
		totalCount: data.total || data.totalCount || 0,
		currentPage: data.currentPage || data.page || 1,
		perPage: data.perPage || data.per_page || 12,
		error: null,
	},
});

export const fetchPortfoliosError = (error) => ({
	type: FETCH_PORTFOLIOS_ERROR,
	payload: {
		isLoading: false,
		error: error,
	},
});

export const createPortfolioRequest = () => ({
	type: CREATE_PORTFOLIO_REQUEST,
	payload: {
		isCreating: true,
		createError: null,
	},
});

export const createPortfolioSuccess = (portfolio) => ({
	type: CREATE_PORTFOLIO_SUCCESS,
	payload: {
		isCreating: false,
		createError: null,
	},
});

export const createPortfolioError = (error) => ({
	type: CREATE_PORTFOLIO_ERROR,
	payload: {
		isCreating: false,
		createError: error,
	},
});

export const updatePortfolioRequest = () => ({
	type: UPDATE_PORTFOLIO_REQUEST,
	payload: {
		isUpdating: true,
		updateError: null,
	},
});

export const updatePortfolioSuccess = (portfolio) => ({
	type: UPDATE_PORTFOLIO_SUCCESS,
	payload: {
		isUpdating: false,
		selectedPortfolio: portfolio,
		updateError: null,
	},
});

export const updatePortfolioError = (error) => ({
	type: UPDATE_PORTFOLIO_ERROR,
	payload: {
		isUpdating: false,
		updateError: error,
	},
});

export const deletePortfolioRequest = () => ({
	type: DELETE_PORTFOLIO_REQUEST,
	payload: {
		isDeleting: true,
		deleteError: null,
	},
});

export const deletePortfolioSuccess = (portfolioId) => ({
	type: DELETE_PORTFOLIO_SUCCESS,
	payload: {
		isDeleting: false,
		deleteError: null,
		deletedPortfolioId: portfolioId,
	},
});

export const deletePortfolioError = (error) => ({
	type: DELETE_PORTFOLIO_ERROR,
	payload: {
		isDeleting: false,
		deleteError: error,
	},
});

export const fetchPortfolioByIdRequest = () => ({
	type: FETCH_PORTFOLIO_BY_ID_REQUEST,
	payload: {
		isLoadingSelected: true,
		selectedError: null,
	},
});

export const fetchPortfolioByIdSuccess = (portfolio) => ({
	type: FETCH_PORTFOLIO_BY_ID_SUCCESS,
	payload: {
		isLoadingSelected: false,
		selectedPortfolio: portfolio,
		selectedError: null,
	},
});

export const fetchPortfolioByIdError = (error) => ({
	type: FETCH_PORTFOLIO_BY_ID_ERROR,
	payload: {
		isLoadingSelected: false,
		selectedError: error,
	},
});

export const addUserToPortfolioRequest = () => ({
	type: ADD_USER_TO_PORTFOLIO_REQUEST,
	payload: {
		isAddingUser: true,
		addUserError: null,
	},
});

export const addUserToPortfolioSuccess = () => ({
	type: ADD_USER_TO_PORTFOLIO_SUCCESS,
	payload: {
		isAddingUser: false,
		addUserError: null,
	},
});

export const addUserToPortfolioError = (error) => ({
	type: ADD_USER_TO_PORTFOLIO_ERROR,
	payload: {
		isAddingUser: false,
		addUserError: error,
	},
});

export const updatePortfolioUserRequest = () => ({
	type: UPDATE_PORTFOLIO_USER_REQUEST,
	payload: {
		isUpdatingUser: true,
		updateUserError: null,
	},
});

export const updatePortfolioUserSuccess = (result) => ({
	type: UPDATE_PORTFOLIO_USER_SUCCESS,
	payload: {
		isUpdatingUser: false,
		updateUserError: null,
	},
});

export const updatePortfolioUserError = (error) => ({
	type: UPDATE_PORTFOLIO_USER_ERROR,
	payload: {
		isUpdatingUser: false,
		updateUserError: error,
	},
});

// Properties Action Creators
export const fetchPortfolioPropertiesRequest = () => ({
	type: FETCH_PORTFOLIO_PROPERTIES_REQUEST,
	payload: {
		isLoadingProperties: true,
		propertiesError: null,
	},
});

export const fetchPortfolioPropertiesSuccess = (data) => {
	const propertiesList = Array.isArray(data)
		? data
		: data?.data || data?.properties || [];
	return {
		type: FETCH_PORTFOLIO_PROPERTIES_SUCCESS,
		payload: {
			isLoadingProperties: false,
			properties: propertiesList,
			propertiesTotalCount:
				data?.total ??
				data?.totalCount ??
				(Array.isArray(data) ? data.length : propertiesList.length),
			propertiesCurrentPage: data?.page || data?.currentPage || 1,
			propertiesPerPage: data?.per_page || data?.perPage || 10,
			propertiesError: null,
		},
	};
};
export const fetchPortfolioAllPropertiesSuccess = (data) => ({
	type: FETCH_PORTFOLIO_PROPERTIES_SUCCESS,
	payload: {
		isLoadingProperties: false,
		allProperties: data.data || [],
		propertiesError: null,
	},
});

export const fetchPortfolioPropertiesError = (error) => ({
	type: FETCH_PORTFOLIO_PROPERTIES_ERROR,
	payload: {
		isLoadingProperties: false,
		propertiesError: error,
	},
});

// Available Properties Action Creators
export const fetchAvailablePropertiesRequest = () => ({
	type: FETCH_AVAILABLE_PROPERTIES_REQUEST,
	payload: {
		isLoadingAvailableProperties: true,
		availablePropertiesError: null,
	},
});

export const fetchAvailablePropertiesSuccess = (properties) => ({
	type: FETCH_AVAILABLE_PROPERTIES_SUCCESS,
	payload: {
		isLoadingAvailableProperties: false,
		availableProperties: properties || [],
		availablePropertiesError: null,
	},
});

export const fetchAvailablePropertiesError = (error) => ({
	type: FETCH_AVAILABLE_PROPERTIES_ERROR,
	payload: {
		isLoadingAvailableProperties: false,
		availablePropertiesError: error,
	},
});

// Add Property to Portfolio Action Creators
export const addPropertyToPortfolioRequest = () => ({
	type: ADD_PROPERTY_TO_PORTFOLIO_REQUEST,
	payload: {
		isAddingProperty: true,
		addPropertyError: null,
	},
});

export const addPropertyToPortfolioSuccess = (result) => ({
	type: ADD_PROPERTY_TO_PORTFOLIO_SUCCESS,
	payload: {
		isAddingProperty: false,
		addPropertyError: null,
	},
});

export const addPropertyToPortfolioError = (error) => ({
	type: ADD_PROPERTY_TO_PORTFOLIO_ERROR,
	payload: {
		isAddingProperty: false,
		addPropertyError: error,
	},
});

// Notifications Action Creators
export const fetchPortfolioNotificationsRequest = () => ({
	type: FETCH_PORTFOLIO_NOTIFICATIONS_REQUEST,
	payload: {
		isLoadingNotifications: true,
		notificationsError: null,
	},
});

export const fetchPortfolioNotificationsSuccess = (data) => ({
	type: FETCH_PORTFOLIO_NOTIFICATIONS_SUCCESS,
	payload: {
		isLoadingNotifications: false,
		notifications: data.data || [],
		notificationsTotalCount: data.total || 0,
		notificationsCurrentPage: data.page || 1,
		notificationsPerPage: data.per_page || 10,
		notificationsError: null,
	},
});

export const fetchPortfolioNotificationsError = (error) => ({
	type: FETCH_PORTFOLIO_NOTIFICATIONS_ERROR,
	payload: {
		isLoadingNotifications: false,
		notificationsError: error,
	},
});

// Remove Property from Portfolio Set Action Creators
export const removePropertyFromPortfolioSetRequest = () => ({
	type: REMOVE_PROPERTY_FROM_PORTFOLIO_SET_REQUEST,
	payload: {
		isRemovingProperty: true,
		removePropertyError: null,
	},
});

export const removePropertyFromPortfolioSetSuccess = () => ({
	type: REMOVE_PROPERTY_FROM_PORTFOLIO_SET_SUCCESS,
	payload: {
		isRemovingProperty: false,
		removePropertyError: null,
	},
});

export const removePropertyFromPortfolioSetError = (error) => ({
	type: REMOVE_PROPERTY_FROM_PORTFOLIO_SET_ERROR,
	payload: {
		isRemovingProperty: false,
		removePropertyError: error,
	},
});

// Property in Portfolio Set Action Creators
export const fetchPropertyInPortfolioSetRequest = () => ({
	type: FETCH_PROPERTY_IN_PORTFOLIO_SET_REQUEST,
	payload: {
		isLoadingPropertyInPortfolioSet: true,
		propertyInPortfolioSetError: null,
	},
});

export const fetchPropertyInPortfolioSetSuccess = (data) => ({
	type: FETCH_PROPERTY_IN_PORTFOLIO_SET_SUCCESS,
	payload: {
		isLoadingPropertyInPortfolioSet: false,
		propertyInPortfolioSet: data.property || null,
		propertyPortfolioSets: data.portfolioSets || [],
		propertyUsers: data.users || [],
		propertyInPortfolioSetError: null,
	},
});

export const fetchPropertyInPortfolioSetError = (error) => ({
	type: FETCH_PROPERTY_IN_PORTFOLIO_SET_ERROR,
	payload: {
		isLoadingPropertyInPortfolioSet: false,
		propertyInPortfolioSetError: error,
	},
});

// User Assigned Properties Action Creators
export const fetchUserAssignedPropertiesRequest = () => ({
	type: FETCH_USER_ASSIGNED_PROPERTIES_REQUEST,
	payload: {
		isLoadingUserAssignedProperties: true,
		userAssignedPropertiesError: null,
	},
});

export const fetchUserAssignedPropertiesSuccess = (properties) => ({
	type: FETCH_USER_ASSIGNED_PROPERTIES_SUCCESS,
	payload: {
		isLoadingUserAssignedProperties: false,
		userAssignedProperties: properties,
		userAssignedPropertiesError: null,
	},
});

export const fetchUserAssignedPropertiesError = (error) => ({
	type: FETCH_USER_ASSIGNED_PROPERTIES_ERROR,
	payload: {
		isLoadingUserAssignedProperties: false,
		userAssignedPropertiesError: error,
	},
});

// Assign Users to Property Action Creators
export const assignUsersToPropertyRequest = () => ({
	type: ASSIGN_USERS_TO_PROPERTY_REQUEST,
	payload: {
		isAssigningUsersToProperty: true,
		assignUsersError: null,
	},
});

export const assignUsersToPropertySuccess = (result) => ({
	type: ASSIGN_USERS_TO_PROPERTY_SUCCESS,
	payload: {
		isAssigningUsersToProperty: false,
		assignUsersError: null,
	},
});

export const assignUsersToPropertyError = (error) => ({
	type: ASSIGN_USERS_TO_PROPERTY_ERROR,
	payload: {
		isAssigningUsersToProperty: false,
		assignUsersError: error,
	},
});

// Remove User from Property Action Creators
export const removeUserFromPropertyRequest = () => ({
	type: REMOVE_USER_FROM_PROPERTY_REQUEST,
	payload: {
		isRemovingProperty: true,
	},
});

export const removeUserFromPropertySuccess = () => ({
	type: REMOVE_USER_FROM_PROPERTY_SUCCESS,
	payload: {
		isRemovingProperty: false,
	},
});

export const removeUserFromPropertyError = (error) => ({
	type: REMOVE_USER_FROM_PROPERTY_ERROR,
	payload: {
		isRemovingProperty: false,
		removePropertyError: error,
	},
});

// Reducer
const portfoliosManagementReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PORTFOLIOS_REQUEST:
		case FETCH_PORTFOLIOS_SUCCESS:
		case FETCH_PORTFOLIOS_ERROR:
		case CREATE_PORTFOLIO_REQUEST:
		case CREATE_PORTFOLIO_SUCCESS:
		case CREATE_PORTFOLIO_ERROR:
		case UPDATE_PORTFOLIO_REQUEST:
		case UPDATE_PORTFOLIO_SUCCESS:
		case UPDATE_PORTFOLIO_ERROR:
		case DELETE_PORTFOLIO_REQUEST:
		case DELETE_PORTFOLIO_SUCCESS:
		case DELETE_PORTFOLIO_ERROR:
		case FETCH_PORTFOLIO_BY_ID_REQUEST:
		case FETCH_PORTFOLIO_BY_ID_SUCCESS:
		case FETCH_PORTFOLIO_BY_ID_ERROR:
		case ADD_USER_TO_PORTFOLIO_REQUEST:
		case ADD_USER_TO_PORTFOLIO_SUCCESS:
		case ADD_USER_TO_PORTFOLIO_ERROR:
		case FETCH_PORTFOLIO_PROPERTIES_REQUEST:
		case FETCH_PORTFOLIO_PROPERTIES_SUCCESS:
		case FETCH_PORTFOLIO_PROPERTIES_ERROR:
		case FETCH_AVAILABLE_PROPERTIES_REQUEST:
		case FETCH_AVAILABLE_PROPERTIES_SUCCESS:
		case FETCH_AVAILABLE_PROPERTIES_ERROR:
		case ADD_PROPERTY_TO_PORTFOLIO_REQUEST:
		case ADD_PROPERTY_TO_PORTFOLIO_SUCCESS:
		case ADD_PROPERTY_TO_PORTFOLIO_ERROR:
		case FETCH_PORTFOLIO_NOTIFICATIONS_REQUEST:
		case FETCH_PORTFOLIO_NOTIFICATIONS_SUCCESS:
		case FETCH_PORTFOLIO_NOTIFICATIONS_ERROR:
		case REMOVE_PROPERTY_FROM_PORTFOLIO_SET_REQUEST:
		case REMOVE_PROPERTY_FROM_PORTFOLIO_SET_SUCCESS:
		case REMOVE_PROPERTY_FROM_PORTFOLIO_SET_ERROR:
		case FETCH_PROPERTY_IN_PORTFOLIO_SET_REQUEST:
		case FETCH_PROPERTY_IN_PORTFOLIO_SET_SUCCESS:
		case FETCH_PROPERTY_IN_PORTFOLIO_SET_ERROR:
		case FETCH_USER_ASSIGNED_PROPERTIES_REQUEST:
		case FETCH_USER_ASSIGNED_PROPERTIES_SUCCESS:
		case FETCH_USER_ASSIGNED_PROPERTIES_ERROR:
		case ASSIGN_USERS_TO_PROPERTY_REQUEST:
		case ASSIGN_USERS_TO_PROPERTY_SUCCESS:
		case ASSIGN_USERS_TO_PROPERTY_ERROR:
		case REMOVE_USER_FROM_PROPERTY_REQUEST:
		case REMOVE_USER_FROM_PROPERTY_SUCCESS:
		case REMOVE_USER_FROM_PROPERTY_ERROR:
			return {
				...state,
				...action.payload,
			};

		case CLEAR_PORTFOLIO_ERRORS:
			return {
				...state,
				error: null,
				createError: null,
				updateError: null,
				deleteError: null,
				selectedError: null,
				propertiesError: null,
				availablePropertiesError: null,
				addUserError: null,
				addPropertyError: null,
			};

		case CLEAR_SELECTED_PORTFOLIO:
			return {
				...state,
				selectedPortfolio: null,
				selectedError: null,
				properties: [],
				availableProperties: [],
			};

		default:
			return state;
	}
};

export default portfoliosManagementReducer;
